export default "__VITE_ASSET__9b0592f8__"